import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '../store/auth/actions';
import {
  LayoutDashboard,
  Users,
  Shield,
  RefreshCw,
  ScanLine,
  FileText,
  LogOut,
} from 'lucide-react';
import logoTca from '../logo-tca.png';
import './Sidebar.css';

interface NavSection {
  label: string;
  items: Array<{
    path: string;
    label: string;
    icon: React.ElementType;
    end?: boolean;
  }>;
}

const navSections: NavSection[] = [
  {
    label: 'PILOTAGE',
    items: [
      { path: '/espace-admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
    ],
  },
  {
    label: 'UTILISATEURS',
    items: [
      { path: '/espace-admin/utilisateurs', label: 'Utilisateurs', icon: Users },
      { path: '/espace-admin/roles', label: 'Rôles & permissions', icon: Shield },
      { path: '/espace-admin/reassignation', label: 'Réassignation', icon: RefreshCw },
    ],
  },
  {
    label: 'SUPERVISION',
    items: [
      { path: '/espace-admin/numerisation', label: 'Numérisation', icon: ScanLine },
      { path: '/espace-admin/decisions', label: 'Décisions', icon: FileText },
    ],
  },
];

interface AdminSidebarProps {
  onNavClick?: () => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ onNavClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutRequest(navigate));
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-logo">
          <img src={logoTca} alt="TCA" className="sidebar-logo-img" />
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">Administration</span>
            <span className="sidebar-logo-sub">Espace TCA — Pilotage</span>
          </div>
        </div>

        {navSections.map((section) => (
          <div key={section.label} className="sidebar-section">
            <div className="sidebar-section-label">{section.label}</div>
            <nav className="sidebar-nav">
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
                  onClick={onNavClick}
                >
                  <item.icon size={20} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </div>
        ))}
      </div>

      <div className="sidebar-bottom">
        <button className="sidebar-logout" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
